/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Profile_Missing_TitleInputs */

const en_us2_profile_missing_title = /** @type {(inputs: Profile_Missing_TitleInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`1 answer missing`);
	return /** @type {LocalizedString} */ (`${i?.count} answers missing`)
	
};

const pt_br2_profile_missing_title = /** @type {(inputs: Profile_Missing_TitleInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`Falta 1 resposta`);
	return /** @type {LocalizedString} */ (`Faltam ${i?.count} respostas`)
	
};

const es_419_profile_missing_title = /** @type {(inputs: Profile_Missing_TitleInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`Falta 1 respuesta`);
	return /** @type {LocalizedString} */ (`Faltan ${i?.count} respuestas`)
	
};

const pt_pt2_profile_missing_title = /** @type {(inputs: Profile_Missing_TitleInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`Falta 1 resposta`);
	return /** @type {LocalizedString} */ (`Faltam ${i?.count} respostas`)
	
};

const fr_fr2_profile_missing_title = /** @type {(inputs: Profile_Missing_TitleInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`Il manque 1 réponse`);
	return /** @type {LocalizedString} */ (`Il manque ${i?.count} réponses`)
	
};

const de_de2_profile_missing_title = /** @type {(inputs: Profile_Missing_TitleInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`1 Antwort fehlt`);
	return /** @type {LocalizedString} */ (`${i?.count} Antworten fehlen`)
	
};

const it_it2_profile_missing_title = /** @type {(inputs: Profile_Missing_TitleInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`Manca 1 risposta`);
	return /** @type {LocalizedString} */ (`Mancano ${i?.count} risposte`)
	
};

/**
* | count | output |
* | --- | --- |
* | "1" | "1 answer missing" |
* | * | "{count} answers missing" |
*
* @param {Profile_Missing_TitleInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_missing_title = /** @type {((inputs: Profile_Missing_TitleInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Missing_TitleInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_missing_title(inputs)
	if (locale === "es-419") return es_419_profile_missing_title(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_missing_title(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_missing_title(inputs)
	if (locale === "de-DE") return de_de2_profile_missing_title(inputs)
	if (locale === "it-IT") return it_it2_profile_missing_title(inputs)
	return en_us2_profile_missing_title(inputs)
});
export { profile_missing_title as "profile.missing_title" }